import {
  CompletedTransition,
  EditTransition,
  GeneratedTransition,
  HarmObserved,
  ReviewedTransition,
  Sweep,
  SweepCompletedStage,
  SweepEditStage,
  SweepPlayerUpdateStage,
  SweepReviewedStage,
  SweepStatus,
  SweepType,
  UpdateTransition,
} from '@inplay/models';
import { ActionButtonsVisibility } from '../userManagement/userManagement.type';
import { DateRange } from 'react-day-picker';
import { Dispatch, SetStateAction } from 'react';

export type SweepProps = {};

export type SweepsTableHeaderProps<OptionKey extends string = string> = {
  searchQuery: string;
  handleOnChangeSearch: (value: string) => void;
  onSettingMenuSelect?: (label: string | undefined) => void;
  selectedCount: number;
  reportLabel?: string;
  selectedDate?: Date;
  unitTranslationKey: string;
  handleSelectedDate?: (date: Date) => void;
  disableSettingMenu?: boolean;
  handleClose?: () => void;
  handleDelete?: () => void;
  handleDownload?: () => void;
  actionVisibility?: ActionButtonsVisibility;
  handleApprove?: () => void;
  showDownloadLoading?: boolean;
};

export enum SweepKebabOption {
  ViewEditHistory = 'View edit history',
  Download = 'Download',
  Edit = 'Edit',
}

export enum SweepTableHeader {
  SWEEP_NO = 'Sweep No.',
  NO = 'No.',
  STATUS = 'Status',
  SWEEP_TYPE = 'Sweep Type',
  TIME = 'Time',
  HOUR = 'Hour',
  NO_OF_PLAYER = 'No. of players',
  HARM_OBSERVED = 'Harm observed',
  COMPLETED_BY = 'Completed by',
  REVIEWED_BY = 'Reviewed by',
  ACTION = 'Actions',
}

export type SweepsTableFilterProps = {
  toggleFilterModal: (val: boolean) => void;
  isOpenUserModal: boolean;
  filters: SweepFilters;
  setFilters: Dispatch<SetStateAction<SweepFilters>>;
  selectedBranchIDs: string[];
  sweepsSummary: Sweep[];
  handleFilterApply: (filters: SweepFilters) => void;
  handleClearFilter: () => void;
};

export type SweepFilters = {
  dateRange: DateRange;
  time: { from: string | undefined; until: string | undefined };
  hours: string[];
  status: SweepStatus[];
  sweepType: SweepType[];
  harmObserved: HarmObserved | undefined;
  completedBy: string[];
};

export type SweepSummaryParams = {
  startTime?: string;
  endTime?: string;
  venueBranchIds?: string[];
};

export enum SweepKey {
  SWEEP_NO = 'sweepNumber',
}

export enum UserRole {
  STAFF = 'staff',
  MANAGER = 'manager',
}

export type PlayerSelectionOption = 'random' | 'existing';

export type PlayerSelectionProps = {
  selectedOption: PlayerSelectionOption;
  onChange: (value: PlayerSelectionOption) => void;
  randomID: string;
};

export type SweepTransition =
  | EditTransition
  | UpdateTransition
  | GeneratedTransition
  | CompletedTransition
  | ReviewedTransition;

export type SweepStage =
  | SweepEditStage
  | SweepPlayerUpdateStage
  | SweepReviewedStage
  | SweepCompletedStage;
